module.exports = __webpack_public_path__ + "media/landing_page/instagram-cashew-10ef1031.svg";